import { useState, useEffect } from 'react';

const STORAGE_KEY = 'trainaxis_imp_session';

const EMPTY = {
  isImpersonating: false,
  mode:            null,
  isReadOnly:      false,
  isFullAccess:    false,
  clubName:        null,
  clubSlug:        null,
  reason:          null,
  expiresAt:       null,
  sessionId:       null,
};

function readSession() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return EMPTY;
    const s = JSON.parse(raw);
    if (!s?.sessionId || !s?.expiresAt) return EMPTY;
    if (new Date(s.expiresAt) <= new Date()) return EMPTY;
    return {
      isImpersonating: true,
      mode:            s.mode || 'readonly',
      isReadOnly:      s.mode !== 'full_access',
      isFullAccess:    s.mode === 'full_access',
      clubName:        s.clubName || null,
      clubSlug:        s.clubSlug || null,
      reason:          s.reason  || null,
      expiresAt:       s.expiresAt,
      sessionId:       s.sessionId,
    };
  } catch {
    return EMPTY;
  }
}

// Returns live impersonation context, refreshed every second.
// Safe to call when localStorage is empty or malformed.
export default function useImpersonation() {
  const [ctx, setCtx] = useState(() => readSession());

  useEffect(() => {
    const id = setInterval(() => setCtx(readSession()), 1000);
    return () => clearInterval(id);
  }, []);

  return ctx;
}
